/**
 * @(#)2019/7/15.
 * YxSwitch，可以开关操作
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React from "react";
import Switch from "./Switch";
import Basics from "../Basics";
import { cloneDeep, get, set } from "../../../utils";
import { YxComponent, Connection } from "../../YxComponent";

//默认props
/*
 * @param unCheckedChildren {string | ReactNode} 非选中时的显示文字
 * @param checkedChildren {string | ReactNode} 选中时的显示文字
 * @param defaultChecked {boole} 默认是否选中
 * @param checked {boole} 是否选中
 * @param styleParam {object} 样式参数
 * @param styleParam.width {object} 宽度  xxs,xs,sm,md,lg,xl
 * */
export let defaultProps = () => {
  return {
    unCheckedChildren: "",
    checkedChildren: "",
    children: "", //子节点,子节点暂时只支持antd的Checkbox
    inputParam: {},
    rules: {},
    getFieldDecoratorParam: {},
    styleParam: {
      size: "default", //大小
      type: "default", //类型
    },
  };
};
@Connection(defaultProps)
class YxSwitch extends YxComponent {
  productionHtml() {
    let props = { ...this.props };
    props.rules.max = "";
    props.unCheckedChildren
      ? (props.inputParam.unCheckedChildren = props.unCheckedChildren)
      : "";
    props.checkedChildren
      ? (props.inputParam.checkedChildren = props.checkedChildren)
      : "";
    if (props.defaultChecked === false || props.defaultChecked === true) {
      props.inputParam.defaultChecked = props.defaultChecked;
    }
    if (props.checked === false || props.checked === true) {
      props.inputParam.checked = props.checked;
    }
    props.getFieldDecoratorParam.valuePropName = "checked";
    props.children = <Switch form={this.props.form} />;
    let classParam = {
      yx_yxSwitch_: "styleParam.type",
      yx_yxSwitch_size_: "styleParam.size",
    };
    set(props, "getFieldDecoratorParam.valuePropName", "value");
    set(props, "getFieldDecoratorParam.validateTrigger", "onChange");
    set(props, "getFieldDecoratorParam.trigger", "onChange");
    props.inputParam.className = this.styleParamClassName(props, classParam);
    let html = Basics.html(props);
    return html;
  }
  render() {
    return this.productionHtml();
  }
}
export default YxSwitch;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxSwitch/yxSwitch.js